<div class="wrapper" [formGroup]="formGroup">    
        
    <div class="nsw-form__group">

        <fieldset class="nsw-form__fieldset">
            <legend>
                <span class="nsw-form__legend nsw-form__required">Filter by:<span class="sr-only"> (required)</span></span>                    
            </legend>

            <div> <!-- can use a form group for radio buttons if the n number of options are more-->
                <input class="nsw-form__radio-input" type="radio" name="filterBy" aria-haspopup="dialog"
                    [id]="'waterQualityDataFilterBy' + FILTER_BY[0]" formControlName="filterBy" [value]="FILTER_BY[0]">
                <label class="nsw-form__radio-label" [for]="'waterQualityDataFilterBy' + FILTER_BY[0]">{{FILTER_BY[0]}}</label>
                
                <input class="nsw-form__radio-input" type="radio" name="filterBy" aria-haspopup="dialog"
                    [id]="'waterQualityDataFilterBy' + FILTER_BY[1]" formControlName="filterBy" [value]="FILTER_BY[1]">
                <label class="nsw-form__radio-label" [for]="'waterQualityDataFilterBy' + FILTER_BY[1]">{{FILTER_BY[1]}}</label>
                
                <input class="nsw-form__radio-input" type="radio" name="filterBy" aria-haspopup="dialog" 
                    [id]="'waterQualityDataFilterBy' + FILTER_BY[2]" formControlName="filterBy" [value]="FILTER_BY[2]">
                <label class="nsw-form__radio-label" [for]="'waterQualityDataFilterBy' + FILTER_BY[2]">{{FILTER_BY[2]}}</label>
            </div> 
            <span *ngIf="required && filterBy?.touched && filterBy?.invalid" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper">
                <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                Please select atleast one option
            </span>                
        </fieldset>
    </div>       
   
   

    <ng-container *ngIf="filterBy?.value">
        <div class="nsw-form__group">
            <label class="nsw-form__label" for="form-text-filterByKeyword">Filter by keyword</label>            
            <div class="nsw-form__input-group nsw-form__input-group--icon">
                <label class="sr-only" for="form-text-filterByKeyword">Search</label>
                <input class="nsw-form__input" type="text" id="form-text-filterByKeyword" 
                    name="form-text-filterByKeyword" formControlName="filterByKeyword"
                    [placeholder]="'Search ' + filterBy?.value" />
                <button class="nsw-button nsw-button--white nsw-button--flex" type="button" 
                    role="button"
                    (click)="applyFilter()" [attr.aria-label]="'Search ' + filterBy?.value">
                    <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true" alt="Search">search</span>
                </button>
            </div>
        </div>
        
        <div class="nsw-form__group">
            <fieldset class="nsw-form__fieldset">
                <legend>
                    <span class="nsw-form__legend" [class.nsw-form__required]="required">
                        Select one or more from the list below
                        <span class="sr-only"></span>
                    </span>
                </legend>

                <div class="list-container" *ngIf="FILTER_BY[0] === filterBy?.value" formArrayName="regionsArray">                    
                    <ng-container *ngFor="let control of regionsFormArray.controls; let regionIdx = index;">
                        <ng-container *ngIf="areaShown(areaLookupTypes.Region, regionIdx)" [formGroupName]="regionIdx">                                
                            <div class="nsw-form__input-group nsw-form__input-group--icon">                               
                                <a  
                                    (click)="onExpandButtonClicked($event, areaLookupTypes.Region, regionIdx)" [tabIndex]="0"
                                    type="button">
                                    <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">
                                        {{!isExpanded(areaLookupTypes.Region, regionIdx) ? 'chevron_right' : 'expand_more'}}
                                    </span>
                                </a>
                                <input class="nsw-form__checkbox-input"
                                    type="checkbox" [name]="areaLookupTypes.Region"
                                    [formControlName]="areaLookupTypes.Region"
                                    [id]="areaLookupTypes.Region + '-' + regionIdx"
                                    (change)="onAreaCheckedChanged(regionIdx)" />
                                <label class="nsw-form__checkbox-label no-margin-top"
                                    [for]="areaLookupTypes.Region + '-' + regionIdx">
                                    {{getAreaLabel(areaLookupTypes.Region, regionIdx)}}
                                </label>  
                            </div>
                            <div [formArrayName]="areaLookupTypes.RegionBeachSite" class="nested-list"  
                                *ngIf="isExpanded(areaLookupTypes.Region, regionIdx)">
                                <ng-container *ngFor="let site of getAreaBeachSiteControls(regionIdx, areaLookupTypes.Region)?.controls; let siteIdx = index">
                                    <ng-container *ngIf="areaShown(areaLookupTypes.RegionBeachSite, regionIdx, siteIdx)">
                                        <div class="nsw-form__input-group">
                                            <input class="nsw-form__checkbox-input"
                                                type="checkbox" [name]="areaLookupTypes.RegionBeachSite"
                                                [formControlName]="siteIdx" 
                                                [id]="areaLookupTypes.RegionBeachSite + '-' + siteIdx"
                                                (change)="onAreaBeachSiteChanged(regionIdx, siteIdx)" />
                                            <label class="nsw-form__checkbox-label nested-checkbox-label" 
                                                [for]="areaLookupTypes.RegionBeachSite + '-' + siteIdx">
                                                {{getAreaLabel(areaLookupTypes.RegionBeachSite, regionIdx, siteIdx)}}
                                            </label>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </ng-container>                           
                    </ng-container>                                 
                </div>

                <div class="list-container" *ngIf="FILTER_BY[1] === filterBy?.value" formArrayName="councilsArray">                   
                    <ng-container *ngFor="let control of councilsFormArray.controls; let councilIdx = index;">
                        <ng-container *ngIf="areaShown(areaLookupTypes.Council, councilIdx)" [formGroupName]="councilIdx">                                
                            <div class="nsw-form__input-group nsw-form__input-group--icon">                                 
                                <a  
                                    (click)="onExpandButtonClicked($event, areaLookupTypes.Council, councilIdx)" [tabIndex]="0"
                                    type="button">
                                    <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">
                                        {{!isExpanded(areaLookupTypes.Council, councilIdx) ? 'chevron_right' : 'expand_more'}}
                                    </span>
                                </a>
                                <input class="nsw-form__checkbox-input"
                                    type="checkbox" [name]="areaLookupTypes.Council"
                                    [formControlName]="areaLookupTypes.Council"
                                    [id]="areaLookupTypes.Council + '-' + councilIdx"
                                    (change)="onAreaCheckedChanged(councilIdx)" />
                                <label class="nsw-form__checkbox-label no-margin-top"
                                    [for]="areaLookupTypes.Council + '-' + councilIdx">
                                    {{getAreaLabel(areaLookupTypes.Council, councilIdx)}}
                                </label>  
                            </div>
                            <div [formArrayName]="areaLookupTypes.CouncilBeachSite" class="nested-list" 
                                *ngIf="isExpanded(areaLookupTypes.Council, councilIdx)">
                                <ng-container *ngFor="let site of getAreaBeachSiteControls(councilIdx, areaLookupTypes.Council)?.controls; let siteIdx = index">
                                    <ng-container *ngIf="areaShown(areaLookupTypes.CouncilBeachSite, councilIdx, siteIdx)">
                                        <div class="nsw-form__input-group">
                                            <input class="nsw-form__checkbox-input"
                                                type="checkbox" [name]="areaLookupTypes.CouncilBeachSite"
                                                [formControlName]="siteIdx" 
                                                [id]="areaLookupTypes.CouncilBeachSite + '-' + siteIdx"
                                                (change)="onAreaBeachSiteChanged(councilIdx, siteIdx)" />
                                            <label class="nsw-form__checkbox-label nested-checkbox-label" 
                                                [for]="areaLookupTypes.CouncilBeachSite + '-' + siteIdx">
                                                {{getAreaLabel(areaLookupTypes.CouncilBeachSite, councilIdx, siteIdx)}}
                                            </label>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </ng-container>                           
                    </ng-container>
                </div>

                <div class="list-container" *ngIf="FILTER_BY[2] === filterBy?.value" formArrayName="beachSitesArray">                    
                    <ng-container *ngFor="let control of beachSitesFormArray.controls; let siteIdx = index;"> 
                        <ng-container *ngIf="areaShown(areaLookupTypes.BeachSite, siteIdx)">
                            <div class="nsw-form__input-group">
                                <input type="checkbox" class="nsw-form__checkbox-input" 
                                    [id]="areaLookupTypes.BeachSite + '-' + siteIdx" 
                                    [formControl]="asFormControl(control)"/>

                                <label class="nsw-form__checkbox-label no-margin-top"
                                    [for]="areaLookupTypes.BeachSite + '-' + siteIdx">
                                    {{getAreaLabel(areaLookupTypes.BeachSite, siteIdx)}}
                                </label>                                                                                 
                            </div>   
                        </ng-container>       
                    </ng-container>
                </div> 
            </fieldset>
        </div>
        <div class="clear-selections">
            <a 
                href="javascript:void(0)"
                (click)="clearSelectedAreaOptions()"                         
                role="button"
                class="nsw-link nsw-link--icon"
                aria-haspopup="dialog" >Clear selections</a>
            <a (click)="selectAllAreaOptions()" 
                href="javascript:void(0)"                        
                [tabindex]="0"
                role="button"
                class="nsw-link nsw-link--icon"
                aria-haspopup="dialog" >Select all</a>
        </div>

        <span *ngIf="!selectionValid" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper" style="margin-top:24px;">
            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
            {{validationErrorMessage}}
        </span>
          <!-- <div class="text-red" *ngIf="!selectionValid">{{validationErrorMessage}}</div> -->
    </ng-container>                              
</div>
